import React from 'react';

import { LayoutDefault } from '../../shared/ui';

function InviteSending() {
  return (
    <LayoutDefault>
      <h2>Invitation Sent</h2>
      Your invitations have been sent and Profyle will alert you each time someone responds.
    </LayoutDefault>
  );
}

export { InviteSending };
